var render = function render(){var _vm=this,_c=_vm._self._c;return _c('BaseDropdown',{scopedSlots:_vm._u([{key:"activator",fn:function(){return [_vm._v("\n        "+_vm._s(_vm.title)+"\n    ")]},proxy:true},{key:"items",fn:function(){return [_vm._t("default")]},proxy:true}],null,true)})
}
var staticRenderFns = []

export { render, staticRenderFns }